import { apiClient } from "../API/axiosInstance";

/**
 * Service class for contact operations
 */
export class ContactService {
  static async fetchContacts(orgID) {
    if (orgID === undefined || orgID === 0) return [];
    const result = await apiClient.get(`/contact/organisation/${orgID}`);
    return result.data || [];
  }

  static async fetchContact(contactId) {
    const result = await apiClient.get(`/contact/${contactId}`);
    return result.data;
  }

  static async createContact(contactData) {
    const response = await apiClient.post("/contact", contactData);
    return response;
  }

  static async updateContact(contactId, contactData) {
    const response = await apiClient.put(`/contact/${contactId}`, contactData);
    return response;
  }

  static async deleteContact(contactId) {
    const response = await apiClient.delete(`/contact/${contactId}`);
    return response;
  }
}
